import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=53eaaa33"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"
import style0 from "./Books.vue?vue&type=style&index=0&id=53eaaa33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports